import { createRouter, createWebHistory } from "vue-router";
import { t } from "@/controllerLK/AvalLocalization";
import NewsPage from "@/pages/NewsPage.vue";
import MapPage from "@/pages/MapPage.vue";
import PulsePage from "@/pages/PulsePage.vue";
import AnalyticsPage from "@/pages/AnalyticsPage.vue";
import {analyticsRoutes} from "@/router/analytic-router";
import SourcePage from "@/pages/SourcePage.vue";

const routes = [
  {
    path: "/login",
    name: "login",
  },
  {
    path: "/lk/:pathMatch(.*)*",
    component: { template: "<div></div>" },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/news",
  },
  {
    path: "/under-construction",
    name: "under-construction",
    props: true,
  },
  {
    path: "/map",
    component: MapPage,
  },
  {
    path: "/pulse",
    component: PulsePage,
  },
  {
    path: "/news",
    component: NewsPage,
  },
  {
    path: "/project-sources",
    component: SourcePage,
  },
  {
    path: "/country-data",
    component: AnalyticsPage,
    props: true,
    children: analyticsRoutes,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  document.title = to.meta.title || t("main_router.aval");
});

export default router;